'use client';

import { c as _c } from "react/compiler-runtime";
import { RefreshRouteOnSave as PayloadLivePreview } from '@payloadcms/live-preview-react';
import { useRouter } from 'next/navigation';
import React from 'react';
export const LivePreviewListener: React.FC = () => {
  const $ = _c(2);
  const router = useRouter();
  let t0;
  if ($[0] !== router.refresh) {
    t0 = <PayloadLivePreview refresh={router.refresh} serverURL={process.env.NEXT_PUBLIC_SERVER_URL as string} />;
    $[0] = router.refresh;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};